import React from 'react';
import { Loader, getTranslation } from '@resy/ui-kitchen';
import './AmexLoading.scss';

const AmexLoading = React.memo(() => (
  <div
    role="alert"
    aria-busy="true"
    aria-label={getTranslation({
      translationKey: 'communication_loading_message',
      fallback: 'Loading...',
    })}
  >
    <Loader className="AmexLoading__loader" />
  </div>
));

export default AmexLoading;
